<template>
  <!-- 设置密码组件 -->
  <div class="set-pwd-container">
    <el-form
      :model="formData"
      :rules="rules"
      ref="formData"
      label-width="100px"
      class="set-pwd-form"
    >
      <!-- form-start -->
      <el-form-item label="新密码:" prop="password">
        <el-input
          v-model="formData.password"
          type="password"
          placeholder="请输入新密码"
        ></el-input>
      </el-form-item>
      <el-form-item label="确认新密码:" prop="checkPassword">
        <el-input
          v-model="formData.checkPassword"
          type="password"
          placeholder="请确再次输入新密码"
        ></el-input>
      </el-form-item>
      <!-- btn -->
      <el-form-item>
        <div class="set-pwd-sub">
          <el-button
            :loading="loading"
            type="primary"
            @click.native="SetPassWordSubmit('formData')"
            >确认</el-button
          >
        </div>
      </el-form-item>
      <!-- form-end -->
    </el-form>
  </div>
</template>

<script>
export default {
  name: 'PassWordInput',
  props: {
    post: {
      type: Object
    }
  },
  data() {
    var validatePassword = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!/^(?=.*[a-zA-Z])(?=.*\d)[\S]{6,18}$/.test(value)) {
        callback(new Error('密码为6-18位的字母数字组合'))
      } else {
        if (this.formData.checkPassword !== '') {
          this.$refs.formData.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePassword2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.formData.password) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      formData: {
        password: '',
        checkPassword: ''
      },
      loading: false,
      rules: {
        password: [{ validator: validatePassword, trigger: 'blur' }],
        checkPassword: [{ validator: validatePassword2, trigger: 'blur' }]
      },
      postContent: {
        spaceMax: 60
      },
      btn: {
        text: '发送验证码',
        spaceMax: 60,
        space: 0,
        busy: false,
        timer: Object
      }
    }
  },
  computed: {},
  created() {
    Object.assign(this.postContent, this.post)
    this.btn.spaceMax = this.postContent.spaceMax
  },
  methods: {
    SetPassWordSubmit(formName) {
      this.loading = true
      var state = false
      this.$refs[formName].validate(valid => {
        if (valid) {
          state = true
          console.log('this.formData', this.formData)
          this.$emit('SetPassWordSubmit', this.formData)
        } else {
          console.log('error submit!!')
        }
        this.loading = false
        return state
      })
    }
  }
}
</script>
<style>
.set-pwd-container .set-pwd-form .el-form-item {
  margin-bottom: 30px;
}
.set-pwd-container .set-pwd-sub .el-button {
  width: 140px;
}
</style>
<style lang="scss" scoped>
.set-pwd-container {
  display: flex;
  width: 460px;
  .set-pwd-form {
    width: 100%;
    .set-pwd-code-bg {
      display: flex;
      width: 100%;
      .set-pwd-code-inp {
        width: 210px;
      }
      .set-pwd-code-send {
        margin-left: 16px;
        display: flex;
        align-items: center;
        .set-pwd-code-btn {
          text-align: center;
          cursor: pointer;
          width: 140px;
          height: 40px;
          border-radius: 5px;
          border: solid 1px #046bcc;
          background: none;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          letter-spacing: 0px;
          color: #046bcc;
        }
        .send-code-busy {
          border-color: #ebebeb;
          color: #928282;
          cursor: default;
        }
      }
    }
    .set-pwd-sub {
      margin-top: 20px;
      width: 180px;
    }
  }
}
</style>
